const SQLITE_DATETIME_RE = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

function parseLastSeen(value) {
  if (!value) {
    return null;
  }

  const raw = String(value).trim();
  if (!raw) {
    return null;
  }

  const normalized = SQLITE_DATETIME_RE.test(raw)
    ? raw.replace(" ", "T") + "Z"
    : raw;

  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
}

export function formatLastSeen(value) {
  const date = parseLastSeen(value);
  if (!date) {
    return "—";
  }

  return date.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
  });
}

export function formatPresenceStatus(isOnline, lastSeen) {
  if (Boolean(isOnline)) {
    return "Сейчас онлайн";
  }

  const formatted = formatLastSeen(lastSeen);
  if (formatted === "—") {
    return "Был(а) онлайн: —";
  }

  return `Был(а) онлайн: ${formatted}`;
}
